// Default loader size
export const DEFAULT_SIZE = 10;
